import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { useHandlers } from '../../../../context/page-context';
import { useClearPriceList } from '../../hooks/use-clear-price-list';
import type { PriceList } from '../../types';

export function ClearPriceListModal({
  priceList,
  isOpen,
  closeModal,
}: {
  priceList: PriceList | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();
  const clearPriceList = useClearPriceList();

  if (!priceList) {
    return null;
  }

  // Using arrow function here to avoid hoisting
  const handleClear = () => {
    clearPriceList.mutate(priceList.slug, {
      onError: () => {
        notificationHandler.error(t('price_lists.notifications.errors.clear_failed'));
      },
      onSuccess: () => {
        notificationHandler.success(
          t('price_lists.notifications.success.clear_succeeded', { name: priceList.name }),
        );
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      primaryAction={{
        text: t('pages:price_lists.modals.confirm_clear.clear'),
        onClick: () => {
          handleClear();
          closeModal();
        },
        danger: true,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: closeModal,
      }}
    >
      <Modal.Header>
        {t('price_lists.modals.confirm_clear.title', { name: priceList.name })}
      </Modal.Header>
      <Modal.Body>
        <Text variant="secondary" size="sm">
          <Trans
            i18nKey="price_lists.modals.confirm_clear.body"
            values={{ name: priceList.name }}
          />
        </Text>
      </Modal.Body>
    </Modal>
  );
}
